/* Shoppable Reels - carousel + fullscreen reel player (Atraa custom, no app) */
(function () {
  function initInstance(root) {
    if (root.dataset.rlInit) return;
    root.dataset.rlInit = '1';
    var track = root.querySelector('.js-track');
    var player = document.getElementById(root.dataset.player || '');

    /* carousel arrows */
    function cardW() { var c = track && track.querySelector('.rl-card'); return c ? c.offsetWidth + 16 : 296; }
    var pv = root.querySelector('.rl-nav.prev'), nx = root.querySelector('.rl-nav.next');
    if (pv) pv.addEventListener('click', function () { track.scrollBy({ left: -cardW(), behavior: 'smooth' }); });
    if (nx) nx.addEventListener('click', function () { track.scrollBy({ left: cardW(), behavior: 'smooth' }); });

    /* card videos: autoplay in view + spinner */
    var cardVids = root.querySelectorAll('.js-card-video');
    cardVids.forEach(function (v) {
      v.muted = true; v.setAttribute('playsinline', '');
      var card = v.closest('.rl-card');
      v.addEventListener('playing', function () { card.classList.add('is-playing'); });
      v.addEventListener('waiting', function () { card.classList.remove('is-playing'); });
    });
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) { var v = e.target; if (e.isIntersecting) { v.play && v.play().catch(function () {}); } else { v.pause && v.pause(); } });
      }, { threshold: 0.4 });
      cardVids.forEach(function (v) { io.observe(v); });
    }

    /* player elements */
    var scroller = player ? player.querySelector('.js-scroll') : null;
    var slides = player ? player.querySelectorAll('.rlp-slide') : [];
    var pVids = player ? player.querySelectorAll('.js-player-video') : [];
    var globalMuted = true;
    var pIO = null;

    function closePlayer() {
      if (!player || !player.classList.contains('open')) return;
      player.classList.remove('open');
      document.body.classList.remove('rl-lock');
      pVids.forEach(function (v) { v.pause && v.pause(); });
      slides.forEach(function (sl) { sl.classList.remove('panel-open'); });
    }

    /* shared: variant panel toggle + AJAX add-to-cart wired to theme cart drawer */
    function wireZone(zone, holder) {
      var toggle = zone.querySelector('.js-toggle-panel');
      if (toggle) toggle.addEventListener('click', function (e) { e.stopPropagation(); holder.classList.toggle('panel-open'); });
      var add = zone.querySelector('.js-add');
      if (add) add.addEventListener('click', function (e) {
        e.stopPropagation();
        if (add.disabled) return;
        var sel = zone.querySelector('.js-variant');
        var vid = sel ? sel.value : add.dataset.variant;
        if (!vid) return;
        var orig = add.textContent;
        add.disabled = true; add.textContent = 'Adding to cart...';
        var body = JSON.stringify({ items: [{ id: parseInt(vid, 10), quantity: 1 }], sections: ['cart-drawer', 'cart-counter'], sections_url: window.location.pathname });
        var addUrl = (window.routes && window.routes.cart_add_url) ? window.routes.cart_add_url : '/cart/add';
        if (addUrl.indexOf('.js') === -1) addUrl += '.js';
        fetch(addUrl, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: body })
          .then(function (r) { return r.json(); })
          .then(function (data) {
            if (data && (data.status || data.errors)) {
              add.textContent = 'Out of stock';
              setTimeout(function () { add.textContent = orig; add.disabled = false; }, 2000);
              return;
            }
            add.textContent = 'Added';
            holder.classList.remove('panel-open');
            closePlayer();
            var drawer = document.querySelector('cart-drawer');
            if (drawer && data.sections && typeof drawer.renderContents === 'function') {
              drawer.renderContents(data, true);
              if (typeof updateCartCounters === 'function') { try { updateCartCounters(); } catch (err) {} }
            } else { window.location.href = '/cart'; }
            setTimeout(function () { add.textContent = orig; add.disabled = false; }, 1600);
          })
          .catch(function () { add.textContent = orig; add.disabled = false; });
      });
    }
    root.querySelectorAll('.rl-card').forEach(function (card) {
      var zone = card.querySelector('.js-atc-zone');
      if (zone) wireZone(zone, card);
    });
    slides.forEach(function (sl) { var z = sl.querySelector('.js-atc-zone'); if (z) wireZone(z, sl); });

    if (!player) return;

    var SVG_MUTED = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M11 5 6 9H2v6h4l5 4V5z" fill="currentColor" stroke="none"/><line x1="22" y1="9" x2="16" y2="15"/><line x1="16" y1="9" x2="22" y2="15"/></svg>';
    var SVG_ON = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M11 5 6 9H2v6h4l5 4V5z" fill="currentColor" stroke="none"/><path d="M15.5 8.5a5 5 0 0 1 0 7"/><path d="M18.4 5.6a9 9 0 0 1 0 12.8"/></svg>';
    function setMuteIcons() { player.querySelectorAll('.js-mute').forEach(function (b) { b.innerHTML = globalMuted ? SVG_MUTED : SVG_ON; }); }
    player.querySelectorAll('.js-mute').forEach(function (b) {
      b.addEventListener('click', function (e) { e.stopPropagation(); globalMuted = !globalMuted; pVids.forEach(function (v) { v.muted = globalMuted; }); setMuteIcons(); });
    });

    function openPlayer(idx) {
      player.classList.add('open');
      document.body.classList.add('rl-lock');
      var target = slides[idx];
      if (target && scroller) scroller.scrollTop = target.offsetTop;
      pVids.forEach(function (v) { v.muted = globalMuted; v.setAttribute('playsinline', ''); });
      if ('IntersectionObserver' in window && !pIO) {
        pIO = new IntersectionObserver(function (es) {
          es.forEach(function (e) { var v = e.target.querySelector('.js-player-video'); if (!v) return; if (e.isIntersecting) { v.play && v.play().catch(function () {}); } else { v.pause && v.pause(); } });
        }, { root: scroller, threshold: 0.6 });
        slides.forEach(function (sl) { pIO.observe(sl); });
      } else if (target) {
        var v0 = target.querySelector('.js-player-video');
        if (v0) { v0.play && v0.play().catch(function () {}); }
      }
      setMuteIcons();
    }

    root.querySelectorAll('.js-open-player').forEach(function (m) {
      m.addEventListener('click', function () { openPlayer(parseInt(m.dataset.idx, 10) || 0); });
    });
    var closeBtn = player.querySelector('.js-close');
    if (closeBtn) closeBtn.addEventListener('click', closePlayer);
    player.addEventListener('click', function (e) { if (e.target === player) closePlayer(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closePlayer(); });
    function slideH() { return scroller ? scroller.clientHeight : window.innerHeight; }
    var up = player.querySelector('.js-up'), down = player.querySelector('.js-down');
    if (up) up.addEventListener('click', function () { scroller.scrollBy({ top: -slideH(), behavior: 'smooth' }); });
    if (down) down.addEventListener('click', function () { scroller.scrollBy({ top: slideH(), behavior: 'smooth' }); });
  }

  function initAll() { document.querySelectorAll('[data-shoppable-reels]').forEach(initInstance); }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', initAll); } else { initAll(); }
  document.addEventListener('shopify:section:load', initAll);
})();
